const PlayerOverrides = {
  2308948: {
    country: "ES",
  },
};

export default PlayerOverrides;
